export const roleGroups = ({
  is_superuser,
  acts_for_franchise,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
}) => {
  const has_franchise_reach = Boolean(is_franchise_admin || is_franchise_manager || is_franchise_staff);
  return {
    has_franchise_reach,
    works_in_franchise: Boolean(has_franchise_reach || acts_for_franchise),
    runs_franchise: Boolean(acts_for_franchise || is_franchise_admin || is_franchise_manager),
    is_back_office: Boolean(is_superuser || has_franchise_reach),
    sees_all_franchises: Boolean(is_superuser && !acts_for_franchise),
  };
};
